import { Trans, useTranslation } from 'react-i18next';

export default function CoreCompetencies() {
  const { t } = useTranslation();

  const competencies = [
    { icon: 'ri-group-3-fill', titleKey: 'coreCompetencies.c1Title', descKey: 'coreCompetencies.c1Desc' },
    { icon: 'ri-bank-line',       titleKey: 'coreCompetencies.c2Title', descKey: 'coreCompetencies.c2Desc' },
    { icon: 'ri-refresh-line',    titleKey: 'coreCompetencies.c3Title', descKey: 'coreCompetencies.c3Desc' },
    { icon: 'ri-user-star-line',  titleKey: 'coreCompetencies.c4Title', descKey: 'coreCompetencies.c4Desc' },
    { icon: 'ri-user-star-line',  titleKey: 'coreCompetencies.c5Title', descKey: 'coreCompetencies.c5Desc' },
  ];

  return (
    <section className="bg-canvas py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Hook quote */}
        <div className="relative max-w-3xl mx-auto text-center mb-16">
          <span className="absolute -top-6 left-0 font-cormorant text-[96px] leading-none text-sage/30 select-none">&ldquo;</span>
          <p className="font-cormorant text-3xl md:text-4xl font-light text-charcoal leading-[1.45] relative z-10 px-8">
            {t('coreCompetencies.quote')}
          </p>
        </div>

        {/* Section label */}
        <div className="mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">
            {t('coreCompetencies.badge')}
          </span>
          <div className="w-10 h-px bg-sage mt-3" />
        </div>

        {/* Card grid */}
        {/*last card classname can be : 'col-span-2 sm:col-span-2'*/}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-16">
          {competencies.map((item, idx) => (
            <div
              key={item.titleKey}
              className={`rounded-xl p-8 border ${idx === competencies.length - 1 ? 'bg-beige border-transparent  ' : 'bg-canvas border-sage/20 hover:border-sage/40'} transition-colors duration-200`}
            >
              <div className={`w-10 h-10 flex items-center justify-center mb-5 ${idx === competencies.length - 1 ? 'text-white/80' : 'text-sage'}`}>
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className={`font-inter font-semibold text-sm mb-3 ${idx === competencies.length - 1 ? 'text-white' : 'text-charcoal'}`}>
                {t(item.titleKey)}
              </h3>
              <p className={`font-inter text-sm leading-relaxed ${idx === competencies.length - 1 ? 'text-white/75' : 'text-text-muted'}`}>
                {t(item.descKey)}
              </p>
            </div>
          ))}
        </div>

        {/* Approach paragraph */}
        <div className="max-w-4xl mx-auto">
            <h4 className="font-cormorant text-4xl md:text-2xl text-charcoal mb-3">
             {t('coreCompetencies.paragraphTitle')}
            </h4>
            <span className="font-inter text-base text-text-muted leading-[1.8]">
            <Trans
                i18nKey="coreCompetencies.paragraph"
                components={{
                    italic: <em />
                }}
            />
            </span>
        </div>

      </div>
    </section>
  );
}
